module.exports = __webpack_public_path__ + "img/no-premium-image.66e2e5be.png";